// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  direction: rtl;
}

/* ===== Layout ===== */
.pro-shell {
  padding: 16px clamp(8px, 2vw, 20px) 24px;
}

.container {
  max-width: 1240px;
  margin: 0 auto;
}

.g-row {
  align-items: flex-start;
}

.col-main, .col-side {
  padding: 0 !important;
}

.sticky {
  position: sticky;
  top: 84px;
  display: grid;
  gap: 14px;
}

/* ===== Header ===== */
.pro-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

:host-context(.ion-color-scheme-dark) .pro-header {
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.pro-title {
  font-weight: 800;
  letter-spacing: 0.2px;
}

.auto-chip {
  border-radius: 12px;
  font-weight: 600;
}

/* ===== Cards ===== */
.card {
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

:host-context(.ion-color-scheme-dark) .card {
  background: #111826;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.section .section-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 14px 16px 0;
}

.s-title {
  font-weight: 800;
  font-size: 1.02rem;
}

.s-sub {
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.92rem;
}

:host-context(.ion-color-scheme-dark) .s-sub {
  color: rgba(255, 255, 255, 0.6);
}

ion-card-content {
  padding: 12px 16px 16px !important;
}

/* ===== Grid & Fields ===== */
.fields-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 12px;
}

.field {
  grid-column: span 12;
}

.field:hover {
  border: 0;
}

@media (min-width: 768px) {
  .field {
    grid-column: span 6;
    display: flex;
    flex-direction: column;
  }
}
@media (min-width: 1100px) {
  .pay-body .field {
    grid-column: span 6;
  }
}
.label {
  font-weight: 700;
  margin: 0 0 6px;
  color: #0f172a;
}

:host-context(.ion-color-scheme-dark) .label {
  color: #e7eefc;
}

.no-break {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* מונע שבירת אות-אות */
.ctrl {
  --background: #fff;
  --color: #0f172a;
  --border-color: rgba(0, 0, 0, .14);
  --border-radius: 12px;
  --highlight-color-focused: var(--ion-color-primary);
  min-height: 45px;
}

:host-context(.ion-color-scheme-dark) .ctrl {
  --background: #0f1320;
  --color: #e7eefc;
  --border-color: rgba(255, 255, 255, .12);
}

.ta {
  min-height: 86px;
}

.dt {
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.14);
}

:host-context(.ion-color-scheme-dark) .dt {
  border-color: rgba(255, 255, 255, 0.12);
}

.toggle {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 6px 12px;
}

:host-context(.ion-color-scheme-dark) .toggle {
  border-color: rgba(255, 255, 255, 0.12);
}

.unit {
  margin-top: 6px;
  font-weight: 700;
  color: #64748b;
}

.hint {
  margin-top: 4px;
  color: #64748b;
  font-size: 0.9rem;
}

.err {
  margin-top: 6px;
  color: #e11d48;
  font-weight: 700;
}

/* ===== Add Bar ===== */
.addbar {
  display: flex;
  gap: 10px;
  align-items: end;
  margin-bottom: 10px;
}

.type-select {
  flex: 1 1 280px;
  --border-color: rgba(0, 0, 0, .14);
}

.add-btn {
  height: 48px;
}

/* ===== Empty ===== */
.empty {
  display: grid;
  place-items: center;
  text-align: center;
  padding: 24px;
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  color: #475569;
}

.empty ion-icon {
  font-size: 32px;
  opacity: 0.7;
}

.empty-title {
  margin-top: 6px;
  font-weight: 800;
}

:host-context(.ion-color-scheme-dark) .empty {
  border-color: rgba(255, 255, 255, 0.18);
  color: #a7b3c9;
}

/* ===== Payments List ===== */
.pay-list {
  display: grid;
  gap: 12px;
}

.pay-card {
  margin: 0;
  border-radius: 0;
  box-shadow: none;
}

:host-context(.ion-color-scheme-dark) .pay-card {
  background: #0f1320;
  border-color: rgba(255, 255, 255, 0.12);
}

.pay-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
}

:host-context(.ion-color-scheme-dark) .pay-head {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.ph-title {
  font-weight: 800;
}

.ph-right {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.amount {
  font-weight: 900;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.1);
  color: #166534;
  border: 1px solid rgba(22, 101, 52, 0.25);
}

:host-context(.ion-color-scheme-dark) .amount {
  background: rgba(34, 197, 94, 0.14);
  color: #86efac;
  border-color: rgba(34, 197, 94, 0.28);
}

.icon-btn {
  --padding-start: 6px;
  --padding-end: 6px;
}

.pay-body {
  padding: 12px;
}

.pay-head, .pay-body {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.pay-head:hover {
  background: rgba(0, 0, 0, 0.03);
  cursor: pointer;
}

/* ===== Summary ===== */
.summary .sum-head {
  padding: 12px 16px 0;
}

.sum-title {
  font-weight: 800;
}

.sum-sub {
  color: #64748b;
}

:host-context(.ion-color-scheme-dark) .sum-sub {
  color: #a7b3c9;
}

.sum-rows {
  display: grid;
  gap: 8px;
  margin: 10px 0 6px;
}

.sum-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cap {
  color: #64748b;
}

.val.strong {
  font-weight: 900;
}

.sum-list {
  display: grid;
  gap: 8px;
  margin-top: 6px;
}

.sum-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  background: #fff;
}

:host-context(.ion-color-scheme-dark) .sum-item {
  background: #0f1320;
  border-color: rgba(255, 255, 255, 0.12);
}

.cta {
  border-radius: 12px;
  font-weight: 800;
  margin-top: 12px;
}

/* ===== Page BG ===== */
.pro-content {
  --background: #fff;
}

/* ===== Ionic parts – חידוד טיפוגרפיה ===== */
ion-input::part(native),
ion-textarea::part(native) {
  font-size: 14.5px;
}

ion-select::part(text) {
  font-size: 14.5px;
}

ion-item.field-item {
  --min-height: 44px;
}

.pay-head .ph-sub {
  display: block;
  font-size: 12px;
  opacity: 0.7;
  margin-top: 2px;
}

.progress {
  height: 6px;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  overflow: hidden;
  margin: 6px 0 10px;
  direction: ltr;
}

.progress .bar {
  height: 100%;
  background: var(--ion-color-success);
}

:host-context(.ion-color-scheme-dark) .progress {
  background: rgba(255, 255, 255, 0.14);
}`, "",{"version":3,"sources":["webpack://./src/core/pages/client-invoice/components/new-invoice/new-invoice.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;AAEF;;AACA,uBAAA;AACA;EACE,wCAAA;AAEF;;AACA;EACE,iBAAA;EACA,cAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,SAAA;AAEF;;AACA,uBAAA;AACA;EACE,4CAAA;AAEF;;AACA;EACE,8CAAA;AAEF;;AACA;EACE,gBAAA;EACA,qBAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;AAEF;;AACA,sBAAA;AACA;EACE,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,0CAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,uCAAA;EACA,0CAAA;AAEF;;AACA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,oBAAA;AAEF;;AACA;EACE,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,0BAAA;EACA,kBAAA;AAEF;;AACA;EACE,+BAAA;AAEF;;AACA;EACE,kCAAA;AAEF;;AACA,8BAAA;AACA;EACE,aAAA;EACA,iDAAA;EACA,SAAA;AAEF;;AACA;EACE,oBAAA;AAEF;;AAAA;EACE,SAAA;AAGF;;AAAA;EACE;IACE,mBAAA;IACA,aAAA;IACA,sBAAA;EAGF;AACF;AADA;EACE;IACE,mBAAA;EAGF;AACF;AAAA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEF;;AACA,uBAAA;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,qBAAA;EACA,mDAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;EACA,wCAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,qCAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,qCAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA,wBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,kCAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA,sBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,uCAAA;EACA,cAAA;AACF;;AAEA,8BAAA;AACA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAGA;EACE,mBAAA;EACA,uCAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,6CAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,yCAAA;AAAF;;AAGA;EACE,mCAAA;EACA,cAAA;EACA,qCAAA;AAAF;;AAGA;EACE,oBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,+BAAA;EACA,eAAA;AAAF;;AAGA,wBAAA;AACA;EACE,oBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,uCAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA,wBAAA;AACA;EACE,kBAAA;AAAF;;AAGA,8CAAA;AACA;;EAEE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EAAY,WAAA;EAAa,+BAAA;EAA6B,oBAAA;EAAsB,gBAAA;EAAkB,kBAAA;EAAoB,cAAA;AAMlH;;AALA;EAAiB,YAAA;EAAc,oCAAA;AAU/B;;AATA;EAAkD,qCAAA;AAalD","sourcesContent":[":host {\n  direction: rtl;\n}\n\n/* ===== Layout ===== */\n.pro-shell {\n  padding: 16px clamp(8px, 2vw, 20px) 24px;\n}\n\n.container {\n  max-width: 1240px;\n  margin: 0 auto;\n}\n\n.g-row {\n  align-items: flex-start;\n}\n\n.col-main, .col-side {\n  padding: 0 !important;\n}\n\n.sticky {\n  position: sticky;\n  top: 84px;\n  display: grid;\n  gap: 14px;\n}\n\n/* ===== Header ===== */\n.pro-header {\n  border-bottom: 1px solid rgba(0, 0, 0, .08);\n}\n\n:host-context(.ion-color-scheme-dark) .pro-header {\n  border-bottom-color: rgba(255, 255, 255, .08);\n}\n\n.pro-title {\n  font-weight: 800;\n  letter-spacing: .2px;\n}\n\n.auto-chip {\n  border-radius: 12px;\n  font-weight: 600;\n}\n\n/* ===== Cards ===== */\n.card {\n  border-radius: 14px;\n  border: 1px solid rgba(0, 0, 0, .08);\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, .06);\n  overflow: hidden;\n}\n\n:host-context(.ion-color-scheme-dark) .card {\n  background: #111826;\n  border-color: rgba(255, 255, 255, .08);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, .35);\n}\n\n.section .section-head {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 14px 16px 0;\n}\n\n.s-title {\n  font-weight: 800;\n  font-size: 1.02rem;\n}\n\n.s-sub {\n  color: rgba(0, 0, 0, .55);\n  font-size: .92rem;\n}\n\n:host-context(.ion-color-scheme-dark) .s-sub {\n  color: rgba(255, 255, 255, .6);\n}\n\nion-card-content {\n  padding: 12px 16px 16px !important;\n}\n\n/* ===== Grid & Fields ===== */\n.fields-grid {\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.field {\n  grid-column: span 12;\n}\n.field:hover{\n  border:0;\n}\n\n@media (min-width: 768px) {\n  .field {\n    grid-column: span 6;\n    display: flex;\n    flex-direction: column;\n  }\n}\n@media (min-width: 1100px) {\n  .pay-body .field {\n    grid-column: span 6;\n  }\n}\n\n.label {\n  font-weight: 700;\n  margin: 0 0 6px;\n  color: #0f172a;\n}\n\n:host-context(.ion-color-scheme-dark) .label {\n  color: #e7eefc;\n}\n\n.no-break {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* מונע שבירת אות-אות */\n\n.ctrl {\n  --background: #fff;\n  --color: #0f172a;\n  --border-color: rgba(0, 0, 0, .14);\n  --border-radius: 12px;\n  --highlight-color-focused: var(--ion-color-primary);\n  min-height: 45px;\n}\n\n:host-context(.ion-color-scheme-dark) .ctrl {\n  --background: #0f1320;\n  --color: #e7eefc;\n  --border-color: rgba(255, 255, 255, .12);\n}\n\n.ta {\n  min-height: 86px;\n}\n\n.dt {\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, .14);\n}\n\n:host-context(.ion-color-scheme-dark) .dt {\n  border-color: rgba(255, 255, 255, .12);\n}\n\n.toggle {\n  border: 1px solid rgba(0, 0, 0, .08);\n  border-radius: 12px;\n  padding: 6px 12px;\n}\n\n:host-context(.ion-color-scheme-dark) .toggle {\n  border-color: rgba(255, 255, 255, .12);\n}\n\n.unit {\n  margin-top: 6px;\n  font-weight: 700;\n  color: #64748b;\n}\n\n.hint {\n  margin-top: 4px;\n  color: #64748b;\n  font-size: .9rem;\n}\n\n.err {\n  margin-top: 6px;\n  color: #e11d48;\n  font-weight: 700;\n}\n\n/* ===== Add Bar ===== */\n.addbar {\n  display: flex;\n  gap: 10px;\n  align-items: end;\n  margin-bottom: 10px;\n}\n\n.type-select {\n  flex: 1 1 280px;\n  --border-color: rgba(0, 0, 0, .14);\n}\n\n.add-btn {\n  height: 48px;\n}\n\n/* ===== Empty ===== */\n.empty {\n  display: grid;\n  place-items: center;\n  text-align: center;\n  padding: 24px;\n  border: 1px dashed rgba(0, 0, 0, .12);\n  border-radius: 12px;\n  color: #475569;\n}\n\n.empty ion-icon {\n  font-size: 32px;\n  opacity: .7;\n}\n\n.empty-title {\n  margin-top: 6px;\n  font-weight: 800;\n}\n\n:host-context(.ion-color-scheme-dark) .empty {\n  border-color: rgba(255, 255, 255, .18);\n  color: #a7b3c9;\n}\n\n/* ===== Payments List ===== */\n.pay-list {\n  display: grid;\n  gap: 12px;\n}\n\n.pay-card {\n  margin: 0;\n  border-radius: 0;\n  box-shadow: none;\n  //background: #fff; border: 1px solid rgba(0,0,0,.08); border-radius: 12px; overflow: hidden;\n}\n\n:host-context(.ion-color-scheme-dark) .pay-card {\n  background: #0f1320;\n  border-color: rgba(255, 255, 255, .12);\n}\n\n.pay-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n}\n\n:host-context(.ion-color-scheme-dark) .pay-head {\n  border-bottom-color: rgba(255, 255, 255, .1);\n}\n\n.ph-title {\n  font-weight: 800;\n}\n\n.ph-right {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.amount {\n  font-weight: 900;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(34, 197, 94, .10);\n  color: #166534;\n  border: 1px solid rgba(22, 101, 52, .25);\n}\n\n:host-context(.ion-color-scheme-dark) .amount {\n  background: rgba(34, 197, 94, .14);\n  color: #86efac;\n  border-color: rgba(34, 197, 94, .28);\n}\n\n.icon-btn {\n  --padding-start: 6px;\n  --padding-end: 6px;\n}\n\n.pay-body {\n  padding: 12px;\n}\n\n.pay-head, .pay-body {\n  border-bottom: 1px solid rgba(0, 0, 0, .06);\n}\n\n.pay-head:hover {\n  background: rgba(0, 0, 0, .03);\n  cursor: pointer;\n}\n\n/* ===== Summary ===== */\n.summary .sum-head {\n  padding: 12px 16px 0;\n}\n\n.sum-title {\n  font-weight: 800;\n}\n\n.sum-sub {\n  color: #64748b;\n}\n\n:host-context(.ion-color-scheme-dark) .sum-sub {\n  color: #a7b3c9;\n}\n\n.sum-rows {\n  display: grid;\n  gap: 8px;\n  margin: 10px 0 6px;\n}\n\n.sum-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cap {\n  color: #64748b;\n}\n\n.val.strong {\n  font-weight: 900;\n}\n\n.sum-list {\n  display: grid;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.sum-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border: 1px solid rgba(0, 0, 0, .08);\n  border-radius: 10px;\n  background: #fff;\n}\n\n:host-context(.ion-color-scheme-dark) .sum-item {\n  background: #0f1320;\n  border-color: rgba(255, 255, 255, .12);\n}\n\n.cta {\n  border-radius: 12px;\n  font-weight: 800;\n  margin-top: 12px;\n}\n\n/* ===== Page BG ===== */\n.pro-content {\n  --background: #fff;\n}\n\n/* ===== Ionic parts – חידוד טיפוגרפיה ===== */\nion-input::part(native),\nion-textarea::part(native) {\n  font-size: 14.5px;\n}\n\nion-select::part(text) {\n  font-size: 14.5px;\n}\n\nion-item.field-item {\n  --min-height: 44px;\n}\n\n.pay-head .ph-sub {\n  display: block;\n  font-size: 12px;\n  opacity: .7;\n  margin-top: 2px;\n}\n\n.progress { height: 6px; background: rgba(0,0,0,.08); border-radius: 999px; overflow: hidden; margin: 6px 0 10px; direction: ltr; }\n.progress .bar { height: 100%; background: var(--ion-color-success); }\n:host-context(.ion-color-scheme-dark) .progress { background: rgba(255,255,255,.14); }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
